<template>
    <v-dialog v-model="openViewC" fullscreen>
        <v-card>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-toolbar dark color="secondary" dense fixed>
                        <v-toolbar-title class="white--text">Reorganize Loads</v-toolbar-title>
                        <v-spacer />
                        <v-btn icon left @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                    </v-toolbar>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <div v-for="shift in filteredPlanA" :key="shift.ShiftDetail">
                            <v-card tile class="mb-4">
                                <v-toolbar :color="shift.isSpecific > 0
                                    ? '#00838F'
                                    : 'primary'
                                    " dark dense>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">
                                                {{ statusIcon }}
                                            </v-icon>
                                        </template>
                                        <span>
                                            Locked by Admin:
                                            <!-- {{ shift.Finalize ? 'Yes' : 'No' }} -->
                                            <br />
                                            Finalized:
                                            {{
                                                shift.DispatchFinalize
                                                    ? 'Yes'
                                                    : 'No'
                                            }}
                                            <v-divider />
                                            Driver login:
                                            {{ shift.LogStart }}
                                            <br />
                                            Driver logout:
                                            {{
                                                shift.LogEnd
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <v-toolbar-title class="ma-2" style="font-size: medium;">
                                        <v-row no-gutters>
                                            <v-col align-self="center" class="mr-2">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-identifier</v-icon>
                                                    {{ shift.ShiftDetail }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2 ">
                                                    <v-icon small left class="mdi-flip-h">mdi-truck-flatbed</v-icon>
                                                    {{ shift.Truck }}
                                                </span>
                                            </v-col>
                                            <v-col align-self="center" class="">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-account</v-icon>
                                                    {{ shift.driver.Name }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2">
                                                    <v-icon small left>mdi-train-car-container</v-icon>
                                                    {{ shift.Trailer }}
                                                </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Start Time: <br />
                                                    {{
                                                        shift.ShiftStartTime
                                                    }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Yard:
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin ==
                                                        1
                                                    "
                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.ExitTime
                                                        }}</span>
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin >
                                                        1
                                                    "
                                                        style="background: red;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.RealExitTime
                                                        }}</span>
                                                    <br />
                                                    {{ shift.Yard }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Shift Hrs: <br />
                                                    {{ shift.HrsAviable }}/{{
                                                        shift.TargetHours
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <!-- <v-toolbar-items>
                                        <v-menu bottom left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item v-for="(item,
                                                    index) in menuItems(shift)" :key="index" @click="item.click">
                                                    <v-list-item-icon>
                                                        <v-icon>{{
                                                            item.icon
                                                        }}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>
                                                        {{ item.title }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar-items> -->
                                </v-toolbar>
                                <v-row class="blue-grey lighten-4" no-gutters>
                                    <v-col cols="6">
                                        <span class="ml-2 font-weight-bold">Load:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 1">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="5">
                                        <span class="ml-2 font-weight-bold">Unload:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 2">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="1" justify="end">
                                        <v-btn plain style="right: 0;">
                                            <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-data-table dense :headers="orderHeaders" :items="shift.orders" item-key="OrderID"
                                    :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true">
                                    <template v-slot:body="props">
                                        <tr v-for="(order,
                                            index) in props.items" :key="order.OrderID" class="py-2" :style="'background:' + order.ColorLoad
                                                ">
                                            <td>
                                                <v-icon :class="order.OrdLoadStatus ===
                                                    'INPROGRESS'
                                                    ? 'bouncing'
                                                    : ''
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        " class="my-2 pa-0 ml-0 grab-icon">
                                                    {{
                                                        getOrderLoadStatus(
                                                            order,
                                                            'icon'
                                                        )
                                                    }}
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :color="getOrderLoadStatus(
                                                    order,
                                                    'color'
                                                )
                                                    ">
                                                    mdi-numeric-{{
                                                        order.LoadNum
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :style="order.LoadNumOrd
                                                    ? ''
                                                    : 'opacity: 0.2;'
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        ">
                                                    mdi-numeric-{{
                                                        order.LoadNumOrd || 0
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>{{ order.OrderID }}
                                                <span v-if="order.OrderStatus != 'DISPATCHED'" class="font-weight-bold"
                                                    :class="order.OrderStatus == 'PRLDISPAT'
                                                        ? 'green--text'
                                                        : order.OrderStatus == 'PRELOAD'
                                                            ? 'orange--text'
                                                            : ''
                                                        " style="font-size: 9px;">
                                                    {{
                                                        order.OrderStatus == 'PRLDISPAT'
                                                            ? 'PREDISPATCH'
                                                            : order.OrderStatus
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2 " label>
                                                    <v-avatar class="py-2" left tile :color="order.Color ||
                                                        'grey'
                                                        ">
                                                        <v-icon small dark>mdi-water-pump</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                                v-on="on">
                                                                {{
                                                                    order.TerminalName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left :color="order
                                                                .terminal
                                                                ?.Color ||
                                                                'grey'
                                                                ">
                                                                mdi-water-pump
                                                            </v-icon>
                                                            {{ order.TerminalName }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2" label>
                                                    <v-avatar class="py-2" left tile color="green ">
                                                        <v-icon small dark>mdi-gas-station</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-stretch: condensed;" v-on="on">
                                                                {{
                                                                    order.StationName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left
                                                                color="green lighten-3">mdi-gas-station</v-icon>
                                                            {{
                                                                order.StationName
                                                            }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>{{ order.StationCity }}</td>
                                            <!-- <td>
                                              
                                            </td> -->
                                            <td>
                                                <span v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.RTTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="order.Finalize !== 1" :class="!closestRunout(order) &&
                                                    order.ROTime
                                                    ? 'font-weight-bold'
                                                    : ''
                                                    ">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.ROTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            order.ETATime,
                                                            'HH'
                                                        )
                                                    }}
                                                </template>
                                                <template v-else>
                                                    <v-icon color="green">mdi-check</v-icon>
                                                </template>
                                            </td>
                                            <td>
                                                {{ order.EstimateTime }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </div>

                        <div style="max-height: 200px;">
                            <!-- Line Up Only - Plan B -->
                            <v-data-table fixed-header dense :headers="headers" :items="filteredLineUp"
                                item-key="OrderID" :items-per-page="-1" :disable-pagination="true"
                                :hide-default-footer="true" height="80vh">
                                <template v-slot:body="props">
                                        <tr @contextmenu.prevent="openContextMenu(order)"
                                            v-for="(order, index) in props.items" :key="order.OrderID" class="py-2">
                                            <td class="custom-cell">
                                                <!-- {{ timeUntil(order.RTTime, 'HH') }} -->
                                                {{ order.RTHrs }}
                                            </td>
                                            <td class="custom-cell">
                                                <!-- {{ timeUntil(order.ROTime, 'HH') }} -->
                                                {{ order.ROHrs }}
                                            </td>
                                            <td class="custom-cell">
                                                {{ order.OrderID }}
                                            </td>
                                            <!-- <td class="custom-cell">
                                            <v-icon small :color="order.TerminalColor">
                                                mdi-water-pump
                                            </v-icon>
                                        </td> -->
                                            <td class="custom-cell">
                                                <v-chip class="ml-2 my-2 " label>
                                                    <v-avatar class="py-2" left tile :color="order.terminal.Color ||
                                                        'grey'
                                                        ">
                                                        <v-icon small dark>mdi-water-pump</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                                v-on="on">
                                                                {{
                                                                    order.TerminalName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left :color="order
                                                                .terminal
                                                                ?.Color ||
                                                                'grey'
                                                                ">
                                                                mdi-water-pump
                                                            </v-icon>
                                                            {{ order.TerminalName }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td class="custom-cell">
                                                {{
                                                    order.StationName
                                                }}
                                            </td>
                                            <td class="custom-cell">
                                                <!-- {{ formatIndependentTime(order.EH) }} -->
                                                {{ order.AVGHE }}
                                            </td>
                                            <td class="custom-cell">
                                                <v-tooltip right>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon small v-on="on" @click="
                                                            $emit('load-details', order)
                                                            ">
                                                            <v-icon
                                                                :color="order.OrderStatus == 'ACTIVE' ? '' : 'green'">mdi-file-document-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-data-table v-if="order.order_details"
                                                        :headers="orderDetailHeaders" :items="order.order_details"
                                                        hide-default-footer disable-sort></v-data-table>
                                                </v-tooltip>
                                            </td>
                                            <td>
                                                <v-icon v-if="order.isSpecific == 1" color="#e6c10b"
                                                    small>mdi-star</v-icon>
                                            </td>
                                        </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-col>
                    <v-col style="overflow: auto;" cols="6">
                        <div v-for="shift in filteredPlanB" :key="shift.ShiftDetail">
                            <v-card tile class="mb-4">
                                <v-toolbar :color="shift.isSpecific > 0
                                    ? '#00838F'
                                    : 'primary'
                                    " dark dense>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on">
                                                {{ statusIcon }}
                                            </v-icon>
                                        </template>
                                        <span>
                                            Locked by Admin:
                                            <!-- {{ shift.Finalize ? 'Yes' : 'No' }} -->
                                            <br />
                                            Finalized:
                                            {{
                                                shift.DispatchFinalize
                                                    ? 'Yes'
                                                    : 'No'
                                            }}
                                            <v-divider />
                                            Driver login:
                                            {{ shift.LogStart }}
                                            <br />
                                            Driver logout:
                                            {{
                                                shift.LogEnd
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <v-toolbar-title class="ma-2" style="font-size: medium;">
                                        <v-row no-gutters>
                                            <v-col align-self="center" class="mr-2">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-identifier</v-icon>
                                                    {{ shift.ShiftDetail }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2 ">
                                                    <v-icon small left class="mdi-flip-h">mdi-truck-flatbed</v-icon>
                                                    {{ shift.Truck }}
                                                </span>
                                            </v-col>
                                            <v-col align-self="center" class="">
                                                <span class="text-subtitle-2 font-weight-bold">
                                                    <v-icon small>mdi-account</v-icon>
                                                    {{ shift.driver.Name }}
                                                </span>
                                                <v-divider />
                                                <span class="text-subtitle-2">
                                                    <v-icon small left>mdi-train-car-container</v-icon>
                                                    {{ shift.Trailer }}
                                                </span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Start Time: <br />
                                                    {{
                                                        shift.ShiftStartTime
                                                    }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Yard:
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin ==
                                                        1
                                                    "
                                                        style="background: #01579b;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.ExitTime
                                                        }}</span>
                                                    <span v-if="
                                                        shift.GPSShiftStartOrigin >
                                                        1
                                                    "
                                                        style="background: red;border-radius: 3px; padding: 2px; color:#fff;">{{
                                                            shift.RealExitTime
                                                        }}</span>
                                                    <br />
                                                    {{ shift.Yard }}</span>
                                            </v-col>
                                            <v-divider vertical class="mx-2" />
                                            <v-col align-self="center">
                                                <span class="text-caption">Shift Hrs: <br />
                                                    {{ shift.HrsAviable }}/{{
                                                        shift.TargetHours
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-menu bottom left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item v-for="(item,
                                                    index) in menuItems(shift)" :key="index" @click="item.click" v-if="item.view == 0">
                                                    <v-list-item-icon>
                                                        <v-icon>{{
                                                            item.icon
                                                            }}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-title>
                                                        {{ item.title }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-row class="blue-grey lighten-4" no-gutters>
                                    <v-col cols="6">
                                        <span class="ml-2 font-weight-bold">Load:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 1">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="5">
                                        <span class="ml-2 font-weight-bold">Unload:</span>
                                        <template v-for="badge in shift.driver.badges">
                                            <abbr style="text-decoration: none;" :title="badge.TerminalName"
                                                v-if="badge.BadgeType == 2">
                                                <v-icon class="my-2 ml-2 "
                                                    :color="badge.Color">mdi-card-bulleted</v-icon>
                                            </abbr>
                                        </template>
                                    </v-col>
                                    <v-col cols="1" justify="end">
                                        <v-btn plain style="right: 0;">
                                            <v-icon>mdi-chevron-up</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-data-table dense :headers="orderHeaders" :items="shift.orders_c" item-key="OrderID"
                                    :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true">
                                    <template v-slot:body="props">
                                        <tr v-for="(order,
                                            index) in props.items" :key="order.OrderID" class="py-2" :style="'background:' + order.ColorLoad
                                                ">
                                            <td>
                                                <v-icon :class="order.OrdLoadStatus ===
                                                    'INPROGRESS'
                                                    ? 'bouncing'
                                                    : ''
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        " class="my-2 pa-0 ml-0 grab-icon">
                                                    {{
                                                        getOrderLoadStatus(
                                                            order,
                                                            'icon'
                                                        )
                                                    }}
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :color="getOrderLoadStatus(
                                                    order,
                                                    'color'
                                                )
                                                    ">
                                                    mdi-numeric-{{
                                                        order.LoadNum
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>
                                                <v-icon :style="order.LoadNumOrd
                                                    ? ''
                                                    : 'opacity: 0.2;'
                                                    " :color="getOrderLoadStatus(
                                                        order,
                                                        'color'
                                                    )
                                                        ">
                                                    mdi-numeric-{{
                                                        order.LoadNumOrd || 0
                                                    }}-box
                                                </v-icon>
                                            </td>
                                            <td>{{ order.OrderID }}
                                                <span v-if="order.OrderStatus != 'DISPATCHED'" class="font-weight-bold"
                                                    :class="order.OrderStatus == 'PRLDISPAT'
                                                        ? 'green--text'
                                                        : order.OrderStatus == 'PRELOAD'
                                                            ? 'orange--text'
                                                            : ''
                                                        " style="font-size: 9px;">
                                                    {{
                                                        order.OrderStatus == 'PRLDISPAT'
                                                            ? 'PREDISPATCH'
                                                            : order.OrderStatus
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2 " label>
                                                    <v-avatar class="py-2" left tile :color="order.Color ||
                                                        'grey'
                                                        ">
                                                        <v-icon small dark>mdi-water-pump</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-family: Tahoma, sans-serif;font-stretch: ultra-condensed;"
                                                                v-on="on">
                                                                {{
                                                                    order.TerminalName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left :color="order
                                                                .terminal
                                                                ?.Color ||
                                                                'grey'
                                                                ">
                                                                mdi-water-pump
                                                            </v-icon>
                                                            {{ order.TerminalName }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip class="ml-2 my-2" label>
                                                    <v-avatar class="py-2" left tile color="green ">
                                                        <v-icon small dark>mdi-gas-station</v-icon>
                                                    </v-avatar>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{
                                                            on
                                                        }">
                                                            <span class="location"
                                                                style="width:180px;font-stretch: condensed;" v-on="on">
                                                                {{
                                                                    order.StationName
                                                                }}
                                                            </span>
                                                        </template>
                                                        <span>
                                                            <v-icon small left
                                                                color="green lighten-3">mdi-gas-station</v-icon>
                                                            {{
                                                                order.StationName
                                                            }}
                                                        </span>
                                                    </v-tooltip>
                                                </v-chip>
                                            </td>
                                            <td>{{ order.StationCity }}</td>
                                            <!-- <td>
                                              
                                            </td> -->
                                            <td>
                                                <span v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.RTTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="order.Finalize !== 1" :class="!closestRunout(order) &&
                                                    order.ROTime
                                                    ? 'font-weight-bold'
                                                    : ''
                                                    ">
                                                    {{
                                                        timeUntil(
                                                            closestRunout(
                                                                order
                                                            ) ?? order.ROTime,
                                                            'HH'
                                                        )
                                                    }}
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="order.Finalize !== 1">
                                                    {{
                                                        timeUntil(
                                                            order.ETATime,
                                                            'HH'
                                                        )
                                                    }}
                                                </template>
                                                <template v-else>
                                                    <v-icon color="green">mdi-check</v-icon>
                                                </template>
                                            </td>
                                            <td>
                                                {{ order.EstimateTime }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
                <confirm-dialogue ref="confirmRplc"></confirm-dialogue>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';

import { dateUtils } from '../../../../components/mixins/dateUtils';
import { dataUtils } from '../../../../components/mixins/dataUtils.js';
import ConfirmDialogue from './../../ConfirmDialogue.vue';

export default {
    props: ['data_c', 'data_a','data_l','openViewC'],

    components: {
        ConfirmDialogue
    },
    data: function () {
        return {
            on: false,
            headerProducts: [
                { text: 'Product', value: 'Product', width: '2' },
                { text: 'Ord QTY', value: 'Quantity', width: '2' },
                { text: 'Disp QTY.', value: 'DispatchedQuantity', width: '2' },
                { text: 'OrderID', value: 'OrderID', width: '2' }
            ],

            orderHeaders: [
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Seq.',
                    value: 'LoadNum',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Split',
                    value: 'LoadNumOrd',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Order ID',
                    value: 'OrderID',
                    sortable: false,
                    width: '1%',
                    align: 'center',
                },
                {
                    text: 'Terminal',
                    value: 'terminal',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Station',
                    value: 'station',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'City',
                    value: 'StationCity',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                },
                // {
                //     text: 'Quantity',
                //     value: 'Qty',
                //     sortable: false,
                //     width: '5%',
                //     align: 'center',
                // },
                {
                    text: 'RT', value: 'RT', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'RO', value: 'RO', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'ETA', value: 'ETA', sortable: false, width: '5%',
                    align: 'center',
                },
                {
                    text: 'EH',
                    value: 'EstimateTime',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                }
            ],
            headers: [
                {
                    text: 'RT',
                    value: 'RTTime',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'RO',
                    value: 'ROTime',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'ID',
                    value: 'OrderID',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },

                // {
                //     text: 'B',
                //     value: 'Bdg',
                //     class: 'custom-header',
                //     cellClass: 'custom-cell',
                //     align: 'center'
                // },
                {
                    text: 'Terminal',
                    value: 'TerminalName',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'Station',
                    value: 'StationName',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'EH',
                    value: 'EH',
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },
                {
                    text: 'Dtl',
                    value: 'details',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                },

                {
                    text: '★',
                    value: '★',
                    sortable: false,
                    class: 'custom-header',
                    cellClass: 'custom-cell',
                    align: 'center'
                }
            ],
            ltrs: [],
            orders: {},
            regions: [],
            cbx: null,
            panel: [],
            order: {},
            lineUp: [],
            search: null,
            filters: ['Terminal', 'Station', 'OrderID', 'StationCity'],
            filterOrd: 'OrderID'
        };
    },
    computed: {
        filteredPlanA() {
            return this.data_a.filter(i => {
                return (
                    !this.cbx || i.PrincipalRegion == this.cbx.PrincipalRegionID
                );
            });
        },
        filteredPlanB() {
            return this.data_c.filter(i => {
                return (
                    !this.cbx || i.PrincipalRegion == this.cbx.PrincipalRegionID
                );
            });
        },
        filteredLineUp() {
            return this.data_l.filter(i => {
                return !this.cbx || i.PrincipalRegionID == this.cbx.PrincipalRegionID;
            });
        },
        menuItems(shift) {
            return shift => {
                let items = [];
                // items.push({
                //     title: 'Refresh',
                //     icon: 'mdi-refresh',
                //     click: () => this.getOrdersByShiftDetail(shift),
                //     condition: true
                // });

                items.push({
                    title: 'Replace in Plan A',
                    icon: 'mdi-file-replace',
                    click: () => this.confirmRemplaceShift(shift),
                    condition: true,
                    view: this.$store.state.currentUser.id == 106 ||  this.$store.state.currentUser.id == 39 || this.$store.state.currentUser.id > 197 ? 0 : 1
                });
                return items;
            };
        },
        statusColor(shift) {
            // if (orders != null) {
            //     // Check if all orders are finalized but the shift is not
            //     const allOrdersFinalized = orders.every(
            //         order => order.Finalize === 1
            //     );
            //     if (
            //         allOrdersFinalized &&
            //         !shift.Finalize &&
            //         !shift.DispatchFinalize
            //     ) {
            //         return 'red darken-2';
            //     }

            //     // Check if any order has status either INPROGRESS or DONE
            //     if (
            //         (orders.some(
            //             order => order.OrdLoadStatus === 'INPROGRESS'
            //         ) ||
            //             orders.some(order => order.OrdLoadStatus === 'DONE')) &&
            //         !shift.Finalize &&
            //         !shift.DispatchFinalize
            //     ) {
            //         return 'blue darken-2';
            //     }

            //     // Check if any order has status READYTOSEND
            //     if (
            //         orders.some(order => order.OrdLoadStatus === 'READYTOSEND')
            //     ) {
            //         return 'yellow darken-2';
            //     }
            // }

            // Default to finalized or pending status for the shift
            return shift.Finalize || shift.DispatchFinalize
                ? 'green darken-2'
                : 'blue-grey darken-2';
        },
        statusIcon(shift, orders) {
            if (orders != null) {
                // Check if all orders are finalized but the shift is not
                const allOrdersFinalized = orders.every(
                    order => order.Finalize === 1
                );
                if (
                    allOrdersFinalized &&
                    !shift.Finalize &&
                    !shift.DispatchFinalize
                ) {
                    return 'mdi-truck-alert';
                }

                // Check if any order has status INPROGRESS
                if (
                    (orders.some(
                        order => order.OrdLoadStatus === 'INPROGRESS'
                    ) ||
                        orders.some(order => order.OrdLoadStatus === 'DONE')) &&
                    !shift.Finalize &&
                    !shift.DispatchFinalize
                ) {
                    return 'mdi-truck-fast';
                }

                // Check if any order has status READYTOSEND
                if (
                    orders.some(order => order.OrdLoadStatus === 'READYTOSEND')
                ) {
                    return 'mdi-email-alert';
                }

                // Check if shift is finalized
                if (shift.Finalize || shift.DispatchFinalize) {
                    return 'mdi-truck-check';
                }
            } else {
                // Default to not started
                return 'mdi-timer-sand';
            }
        },
        statusIconClass(shift, orders) {
            if (orders != null) {
                // Bouncing icon for shifts in progress
                if (
                    orders.some(order => order.OrdLoadStatus === 'INPROGRESS')
                ) {
                    return 'bouncing';
                }

                // Pulsing icon for READYTOSEND or shift not finalized but orders are finalized
                if (
                    orders.some(
                        order => order.OrdLoadStatus === 'READYTOSEND'
                    ) ||
                    (orders.every(order => order.Finalize === 1) &&
                        !shift.Finalize &&
                        !shift.DispatchFinalize)
                ) {
                    return 'pulsing';
                }
            } else {
                // No class for finalized shifts
                return '';
            }
        }
    },
    mounted() {
        console.log('Here', this.data_c);
        console.log('Here', this.data_l);
        // this.getRegions();
        // this.getLineUp();
    },

    mixins: [dateUtils],
    mixins: [dataUtils, dateUtils],
    methods: {

        async confirmRemplaceShift(shift) {
            console.log(shift);
            const ok = await this.$refs.confirmRplc.show({
                title: 'are you sure to replace this shift in Plan A',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.remplacePlanAShiftByShift(shift);
            }
        },
        remplacePlanAShiftByShift: async function (shift) {
            this.$store.state.isLoading = true;
            axios
                .get('dispatch-plan-c/temporal/update/shift/orders/' + shift.ShiftDetail + '/' + this.$store.state.shiftId.ShiftId)
                .then(response => {
                    console.log(response.data);

                    // this.$emit('close');
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        closestRunout(order) {
            const orderDetails = order.order_details; // Properties: ProductType (product_id)
            if (order.station == null) {
                const products = order.station.products; // Properties: product_id, safe_runout_at
                //Get the station product that is closest to runout and is present in the order details
                const closestProduct = products
                    .filter(product =>
                        orderDetails.some(
                            detail => detail.ProductType == product.product_id
                        )
                    )
                    .sort((a, b) => {
                        const aRunout = a.safe_runout_at || Infinity;
                        const bRunout = b.safe_runout_at || Infinity;
                        return aRunout - bRunout;
                    })[0];

                if (!closestProduct) {
                    return null;
                }

                return closestProduct.safe_runout_at;
            }
        },
        getRegions() {
            axios
                .get('region')
                .then(response => {
                    this.regions = response.data.map(x => {
                        if (x.PrincipalRegionID != 4) {
                            return x;
                        }
                    });
                    console.log('Regions', this.regions);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        getLineUp() {
            axios
                .get('dispatch-plan-b-v3/lineup/active')
                .then(response => {
                    this.lineUp = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        printLog: function () {
            console.log(this.filterOrd);
        },
        planBShiftByShift: function (shiftid) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('dispatch-plan-b-v3/by/shift/' + shiftid + '/' + this.header)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    this.openViewC = true;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },

        getOrderLoadStatus(order, type) {
            if (type === 'color') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'yellow darken-2';
                    }
                    case 'NOTSTARTED': {
                        return 'blue-grey lighten-2';
                    }
                    case 'INPROGRESS': {
                        return 'blue darken-2';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'green darken-1';
                    }
                    case 'DONE': {
                        return 'green darken-2';
                    }
                    case 'CANCELLED': {
                        return 'red darken-2';
                    }
                    default: {
                        return 'blue-grey lighten-2';
                    }
                }
            } else if (type === 'icon') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'mdi-email';
                    }
                    case 'NOTSTARTED': {
                        return 'mdi-circle-outline';
                    }
                    case 'INPROGRESS': {
                        return 'mdi-truck-fast';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'mdi-marker-check';
                    }
                    case 'DONE': {
                        return 'mdi-check-circle';
                    }
                    case 'CANCELLED': {
                        return 'mdi-cancel';
                    }
                    default: {
                        return 'mdi-help';
                    }
                }
            } else if (type === 'text') {
                switch (order.OrdLoadStatus) {
                    case 'READYTOSEND': {
                        return 'Ready to Send';
                    }
                    case 'INPROGRESS': {
                        return 'In Progress';
                    }
                    case 'FORCEDCOMPLETION': {
                        return 'Forced Completion';
                    }
                    case 'DONE': {
                        return 'Completed';
                    }
                    case 'CANCELLED': {
                        return 'Cancelled';
                    }
                    default: {
                        return 'Pending';
                    }
                }
            }
        },
    }
};
</script>
<style>
#canvas {
    background-image: url('../../../../assets/trailer.png');
}
</style>
x|
